<template>
<v-card>
    <v-card-title>
<!-- {{ perm }} -->
        <v-spacer></v-spacer>
        <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
    </v-card-title>

    <v-data-table :search="search" :page.sync="page" :items="items" :headers="headers">
        <template v-slot:[`item.tutor_id`]="{ item }">
            <span class="table-tutor-srno">{{item.tutor_id}}</span>
        </template>

        <template v-slot:[`item.name`]="{ item }">
            <router-link class="profile-link" active-class="active" :exact="true" :to="{name: 'TutorProfile',params:{id:item.tutor_id}}">
                <span class="table-tutor-name">{{item.tutor_fname}} {{item.tutor_lname}}</span>
                <span class="table-tutor-email">{{item.tutor_email}}</span>
            </router-link>
        </template>
        <template v-slot:[`item.schedule`]="{ item }">
            <span class="table-tutor-time">{{item.time}}</span>
            <span class="table-tutor-days">
                <v-chip v-for="(day, index) in item.days" :key="index">{{days_formatter(day)}}</v-chip>
            </span>
        </template>
        
        <template v-slot:[`item.subjects`]="{ item }">
            <v-chip v-for="(subject, index) in item.tutor_subject_group" :key="index">
                {{subject.subject.subject_name}}
            </v-chip>
            <!-- <v-chip>{{item}}</v-chip> -->
        </template>
        <template v-slot:[`item.joining_date`]="{ item }">
            <span class="table-tutor-rate">{{formatDate(item.joining_date)}}</span>
        </template>
        <template v-slot:[`item.tutor_per_hour_rate`]="{ item }">
            <span class="table-tutor-rate">{{item.tutor_per_hour_rate}}</span>
        </template>

        <template v-slot:[`item.sessions`]="{ item }">
            <!-- <router-link class="profile-link" active-class :exact="true" :disabled="perm.view" :event="perm.view ? 'click' : ''"
                :to="{name: 'TutorSessions',params:{id:item.tutor_id}}">
                <v-icon color="success">mdi-file-edit</v-icon>
                <v-btn :disabled="!perm.view" > View Sessions</v-btn>
            </router-link> -->

            <router-link class="profile-link" active-class :exact="true" :disabled="perm.t_view" :event="perm.t_view ? 'click' : ''"
                :to="{name: 'TutorSessions',params:{id:item.tutor_id}}">
                <!-- <v-icon color="success">mdi-file-edit</v-icon> -->
                <v-btn :disabled="!perm.t_view" > View Sessions</v-btn>
            </router-link>
        </template>

        <template v-slot:[`item.action`]="{ item }">
            <!-- <router-link class="profile-link" active-class :exact="true" :disabled="perm.edit" :event="perm.edit ? 'click' : ''"
                :to="{name: 'EditTutor',params:{id:item.tutor_id}}">
                <v-icon :disabled="!perm.edit" color="success">mdi-file-edit</v-icon>
            </router-link>
            <v-icon color="red" :disabled="!perm.delete" @click="confirmDelete(item)" @click.stop="dialog = true">mdi-delete</v-icon> -->

            <router-link class="profile-link" active-class :exact="true" :disabled="perm.t_edit" :event="perm.t_edit ? 'click' : ''"
                :to="{name: 'EditTutor',params:{id:item.tutor_id}}">
                <v-icon :disabled="!perm.t_edit" color="success">mdi-file-edit</v-icon>
            </router-link>
            <v-icon color="red" :disabled="!perm.t_delete" @click="confirmDelete(item)" @click.stop="dialog = true">mdi-delete</v-icon>

        </template>
        
    </v-data-table>

    <delete-dialog @success="deleteTutor" :confirm-loading="deleteConfirmLoading" @closeDialog="cancelDelete" :dialog="delete_dialog" title="Tutor"></delete-dialog>
</v-card>
</template>

<script>
import DataTableMixin from "../../mixins/dataTable";
import DeleteRow from "../../mixins/deleteRow";
import DeleteDialog from "../Dialogs/DeleteDialog";
import moment from "moment";

export default {
    name: "TutorTable",
    props: ['perm'],
    components: {
        DeleteDialog
    },
    mixins: [DataTableMixin, DeleteRow],
    data() {
        return {
            search: null,
            dialog: false,
            page: 1,
            pageCount: 3,
            itemsPerPage: 10,
            headers: [{
                    text: "SrNo.",
                    sortable: true,
                    value: "tutor_id"
                },
                {
                    text: "Name",
                    value: "name",
                    sortable: true
                },
                {
                    text: "Phone Number",
                    value: "tutor_contactno",
                    sortable: false
                },
                {
                    text: "Joining Date",
                    value: "joining_date",
                    sortable: false
                },
                {
                    text: "Subjects",
                    value: "subjects",
                    sortable: false
                },
                // { text: "Schedule", value: "schedule", sortable: false },
                {
                    text: "Per Hour Rate",
                    value: "tutor_per_hour_rate",
                    sortable: true
                },
                {
                    text: "Session",
                    value: "sessions",
                    sortable: true,
                    align: "center"
                },
                {
                    text: "Action",
                    value: "action",
                    sortable: true,
                    align: "center"
                },
                {
                    text: 'Full Name',
                    value: 'full_name',
                    align: ' d-none'
                },

            ],
        };
    },
    methods: {
        
        formatDate(date) {
            if(date !== null)
            return moment(date).format('DD-MM-YYYY');
        },
        deleteTutor() {
            this.deleteConfirmLoading = true;
            axios
                .delete(apiRoutes.tutors.url + '/' + this.current_row.tutor_id)
                .then((response) => {
                    console.log(response);
                    this.getItems();
                    this.deleteConfirmLoading = false;
                    this.delete_dialog = false;
                })
                .catch((error) => {
                    this.deleteConfirmLoading = false;
                    this.delete_dialog = false;
                    Toast.fire({
                        icon: 'error',
                        title: 'Cannot Delete Linked Tutor!',
                    });
                });
        },
        getZeroAddedNum(num) {
            return num.toString().padStart(2, "0");
        },
        getItems() {
            axios
                .get(apiRoutes.tutors.url, {
                    params: this.formQueryParams()
                })
                .then((response) => {
                    this.formalizeTable(response.data);
                });
        },
    },
    mounted() {
        this.getItems();
    },
};
</script>

<style lang="scss">
.v-data-table-header th span {
    font: 300 14px Gotham;
    font-family: "Gotham Narrow";
    color: #8898aa;
}

.table-tutor {
    &-srno {
        font: 500 14px/13px Gotham;
        color: #172b4d;
    }

    &-name {
        display: block;
        font: 500 14px/13px Gotham;
        color: #6a158e;
    }

    &-email {
        font: 400 12px/13px Lato;
        color: #172b4d4d;
    }

    &-time {
        display: block;
        font: 400 11px/10px Lato;
        color: #0e0edff7;
    }

    &-days {
        font: 400 10px/15px Lato;
        color: #172b4db3;
    }

    &-rate {
        font: Bold 12px/13px Lato;
        color: #172b4d;
    }
}

.v-btn.v-size--default {
    font-size: 12px;
    text-transform: none;
}
</style>
